import { DEVICE_ID, FCM_TOKEN } from "../constants/localStorageKeys";
import { v4 as uuidv4 } from "uuid";
import { save, retrieve, remove } from "../helpers/StorageHelper";

export const useFcm = () => {

    const getFcmToken = () => {
        const fcmToken = retrieve(FCM_TOKEN);
        let deviceId = retrieve(DEVICE_ID);

        // generate and persist a device id if missing
        if (!deviceId) {
            deviceId = uuidv4();
            save(DEVICE_ID, deviceId);
        }

        return {
            fcmToken,
            deviceId
        };
    };

    const setFcmToken = (token) => {
        save(FCM_TOKEN, token);
    };

    return { getFcmToken, setFcmToken };
};